export enum FieldTypeEnum {
  text = 0,
  number = 1,
  decimal = 2,
  boolean = 3
}